module.exports = __webpack_public_path__ + "static/media/Pichu_gaussian2.7720ef78.png";